import Card from "components/card";
import InputField from "components/fields/InputField";
import Centered from "layouts/auth/types/Centered";
import React, {useState} from "react";
import {FcGoogle} from "react-icons/fc";
import Checkbox from "components/checkbox";
import {Link, useNavigate} from "react-router-dom";
import FixedPlugin from "../../components/fixedPlugin/FixedPlugin";
import {useUserAuth} from "../../context/UserAuthContext";
import axios from "axios";

function SignUp() {
    const navigate = useNavigate();
    let [email, setEmail] = useState("");

    const CROMPTON_URL = process.env.REACT_APP_CROMPTON_SENZE_URL;
    const CROMPTON_ANALYTICS_URL = process.env.REACT_APP_CROMPTON_SENZE_ANALYTICS_URL;

    //const CROMPTON_URL = "https://iot.crompton.co.in:8443/PAPI/"
    const {
        logIn,
        userToken,
        userstate,
        user,
        accesscontrollevel,
        getEmailOtp,
        getMobileOtp,
        verifyEmailOtp,
        verifyMobileOtp,
        resetPassword,
        checkPasswords,
        isValidPassword,
        isValidEmailAddress,
        isValidMobileNumber
    } = useUserAuth();
    const [errorMessage, setErrorMessage] = useState("");

    function checkEmailExists(email) {
        var bodyFormData;
        bodyFormData = {
            email: email,
            action: 1
        }
    //    console.log(bodyFormData)
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkEmail',
            data: bodyFormData
        }).then(async response => {
           //// console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", email)

                    let otpResponse = await getEmailOtp(email)
                    //console.log(otpResponse.status)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        sessionStorage.setItem("pageFrom", "CA")
                        navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }


        })
            .catch(
                error => {
                    //console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            )
    }

    function checkMobileExists(mobileNumber) {
        var bodyFormData;
        bodyFormData = {
            mobile: mobileNumber,
            action: 1
        }
            //console.log(bodyFormData)
        return axios({
            method: 'post',
            url: CROMPTON_URL + 'user/v2/checkMobile',
            data: bodyFormData
        }).then(async response => {
           // console.log(response)
            if (response.status === 200) {
                try {
                    sessionStorage.setItem("email", mobileNumber)

                    let otpResponse = await getMobileOtp(mobileNumber)
                    //console.log(otpResponse)

                    if (otpResponse.status === 200) {
                        setErrorMessage('')
                        sessionStorage.setItem("pageFrom", "CA")
                        navigate("/auth/verify-otp")
                    } else {
                        setErrorMessage(otpResponse.response.data.message)
                    }

                } catch (error) {
                   // console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            } else if (response.status === 208) {
                setErrorMessage(response.data.message)
            }

        })
            .catch(

                error => {
                 //   console.log(error)
                    setErrorMessage(error.response.data.message)
                }
            )
    }

    const navigateToOtpScreen = async (e) => {
        e.preventDefault()

        //setEmail(document.getElementById('email').value)
        email = document.getElementById('email').value
        let password = document.getElementById('password').value

       // console.log(password)

        if(!isValidPassword(password)){
            setErrorMessage("Password is not as per format.")
        }else{
            if (email.includes("@")) {
                if (isValidEmailAddress(email)) {
                    try {
                        sessionStorage.setItem("email", email)
                        sessionStorage.setItem("password", password)
                        checkEmailExists(email)
                        //let otpResponse = await getEmailOtp(email)
                        /*console.log(otpResponse)

                        if (otpResponse.status === 200) {
                            setErrorMessage('')
                            sessionStorage.setItem("pageFrom", "CA")
                            navigate("/senze-2.0/auth/verify-otp")
                        } else {
                            setErrorMessage(otpResponse.response.data.message)
                        }*/

                    } catch (error) {
                       // console.log(error)
                        setErrorMessage(error.response.data.message)
                    }
                    //console.log("email: ", email + "is valid")
                    setErrorMessage("")
                } else {
                    setErrorMessage("The email " + email + "  address is not as per format!!!")

                }
            } else {
                if (isValidMobileNumber(email)) {
                    setErrorMessage("")
                    try {
                        sessionStorage.setItem("email", email)
                        sessionStorage.setItem("password", password)
                        checkMobileExists(email)
                        /*let otpResponse = await getMobileOtp(email)
                        console.log(otpResponse)

                        if (otpResponse.status === 200) {
                            setErrorMessage('')
                            sessionStorage.setItem("pageFrom", "CA")
                            navigate("/senze-2.0/auth/verify-otp")
                        } else {
                            setErrorMessage(otpResponse.response.data.message)
                        }*/

                    } catch (error) {
                       // console.log(error)
                        setErrorMessage(error.response.data.message)
                    }
                    //console.log("mobile: ", email + "is valid")
                } else {
                    setErrorMessage("The mobile number " + email + " is not as per format!!!")

                }
            }
        }


    }

    return (
        <Centered
            maincard={
                <Card
                    extra="max-w-[405px] md:max-w-[510px] h-max mx-2.5 md:mx-auto mt-12 mb-auto py-2.5 px-4 md:!p-[50px] pt-8 md:pt-[50px]">
                    <FixedPlugin/>
                    <h3 className="text-4xl font-bold text-navy-700 dark:text-white">
                        Sign Up
                    </h3>
                    <p className="mt-[10px] ml-1 text-base text-gray-600">
                        Enter your email and password to sign up!
                    </p>
                    {/*<div className="mt-9 flex h-[50px] w-full items-center justify-center gap-2 rounded-xl bg-lightPrimary hover:cursor-pointer dark:!bg-navy-700">
            <div className="rounded-full text-xl">
              <FcGoogle />
            </div>
            <p className="text-sm font-medium text-navy-700 dark:text-white">
              Sign Up with Google
            </p>
          </div>*/}
                    <div className="mt-6 mb-4 flex items-center gap-3">
                        <div className="h-px w-full bg-gray-200 dark:!bg-navy-700"/>
                    </div>
                    {/* user info */}
                    {/* <div className="mb-3 flex w-full items-center justify-center gap-4">
            <div className="w-1/2">
              <InputField
                variant="auth"
                extra="mb-3"
                label="First Name*"
                placeholder="John"
                id="firstname"
                type="text"
              />
            </div>

            <div className="w-1/2">
              <InputField
                variant="auth"
                extra="mb-3"
                label="Last Name*"
                placeholder="Doe"
                id="lastname"
                type="text"
              />
            </div>
          </div>*/}
                    {/* Email */}
                    <InputField
                        variant="auth"
                        extra="mb-3"
                        label="Email or Mobile Number*"
                        placeholder="Email or Mobile Number"
                        id="email"
                        type="email"
                        value = {email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    {/* Password */}
                    <InputField
                        variant="auth"
                        extra="mb-3"
                        label="Password*"
                        placeholder="Min 8 characters"
                        id="password"
                        type="password"
                    />

                    {/* Checkbox */}
                    <div className="mt-2 flex items-center justify-between px-2">
                        <div className="flex">
                            {/*<Checkbox />*/}
                            <p className="ml-2 text-sm font-medium text-navy-700 dark:text-white">
                                By creating an account means you agree to the <a
                                href="https://iot.crompton.co.in/IoT/terms-and-conditions.html" target="_blank" className="font-medium text-[#004c86] hover:text-[#0b83b5]
          active:[#004c86] dark:text-[#0b83b5] dark:hover:text-[#004c86]">Terms and Conditions</a>,
                                and our <a href="https://www.crompton.co.in/pages/privacy-notice" target="_blank"
                                           className="font-medium text-[#004c86] hover:text-[#0b83b5]
          active:[#004c86] dark:text-[#0b83b5] dark:hover:text-[#004c86]">Privacy Notice</a>.
                            </p>
                        </div>
                    </div>

                    <button className=" mt-4 w-full rounded-xl bg-[#004c86] py-3
          text-base font-medium text-white transition duration-200 hover:bg-[#0b83b5]
          active:[#004c86] dark:bg-[#0b83b5] dark:text-white dark:hover:bg-[#004c86]
          dark:active:bg-[#004c86]" onClick={navigateToOtpScreen}>
                        Create my account
                    </button>

                    <div className="mt-3">
            <span className="text-sm font-medium text-navy-700 dark:text-gray-500">
              Already a member?
            </span>
                        {/*<a
                            href="/auth/sign-in"
                            className="ml-1 text-sm font-medium text-[#004c86] hover:text-[#004c86] dark:text-[#004c86]"
                        >
                            Sign In
                        </a>*/}

                        <Link to={"/auth/sign-in"}  className="ml-1 text-sm font-medium text-[#004c86] hover:text-[#004c86] dark:text-[#004c86]">
                            Sign In
                        </Link>

                    </div>
                    <span className="errorMessage">
                        {errorMessage}
                    </span>
                </Card>
            }
        />
    );
}

export default SignUp;
